import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/common.css';
import './AboutUsPage.css';

const AboutUsPage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h2>MAB Jewels (Manoj Abhushan Bhandar, Rajasthan)</h2>
        <p>A Legacy of Trust in Fine Jewellery Since 2002</p>
      </div>

      <div className="about-content">
        {/* Intro/Hero Section */}
        <div className="hero-section">
          <div className="hero-text">
            <h3>Who We Are</h3>
            <p className="hero-description" style={{ fontWeight: '500', color: '#8c6b1f', marginBottom: '15px' }}>
              MAB Jewels is widely recognized in Rajasthan for its certified gold jewellery, transparent pricing, and trusted legacy associated with Manoj Abhushan Bhandar.
            </p>
            <p className="hero-description">
              MAB Jewels, formerly known as Manoj Abhushan Bhandar, is a family-owned jewellery business rooted in the rich cultural heritage of Rajasthan. For over three decades, we have been serving generations of customers with certified gold and silver jewellery, built on a foundation of trust, craftsmanship, and transparent business practices.
            </p>
            <p className="hero-description" style={{ marginTop: '15px' }}>
              Based in Rajasthan with a strong presence in Jodhpur, MAB Jewels is recognized as a trusted jewellery store in Rajasthan, offering timeless designs that blend traditional artistry with modern elegance.
            </p>
            <p className="hero-description" style={{ marginTop: '15px' }}>
              MAB Jewels represents more than just jewellery — it represents relationships built over generations. What began as a small family jewellery shop has evolved into a modern jewellery brand while preserving the values that define us: honesty, purity, and customer respect.
            </p>
            <p className="hero-description" style={{ marginTop: '15px' }}>
              Every ornament at MAB Jewels is crafted with care, certified for purity, and priced transparently — ensuring our customers always receive genuine value and peace of mind.
            </p>
          </div>
          <div className="hero-image">
            <div className="image-placeholder" style={{ backgroundColor: '#f8f5f0', border: '1px solid #d4af37' }}>
              <svg viewBox="0 0 24 24" width="80" height="80" fill="none" stroke="#d4af37" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 3h12l4 6-10 13L2 9Z" />
                <path d="M11 3 8 9l4 13 4-13-3-6" />
                <path d="M2 9h20" />
              </svg>
            </div>
          </div>
        </div>

        {/* Brand Clarification - Critical Update */}
        <div className="brand-clarification" style={{ background: '#fff8e6', padding: '25px', borderRadius: '8px', border: '1px solid #e6cca0', margin: '40px 0', textAlign: 'center' }}>
          <h4 style={{ color: '#8c6b1f', marginBottom: '10px' }}>⚠️ Important Brand Clarification</h4>
          <p style={{ fontSize: '0.95rem', color: '#555' }}>
            <strong>MAB Jewels (Manoj Abhushan Bhandar, Rajasthan)</strong> is an independent, family-owned jewellery business and is not affiliated with any other jewellery brand or business using similar names in other regions of India.
          </p>
        </div>

        {/* Values Section */}
        <div className="values-section">
          <h3>Our Core Values</h3>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <h4>Quality Assurance</h4>
              <p>Every jewellery piece undergoes strict quality checks to ensure BIS hallmark purity, durability, and finishing excellence.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h4>Trust & Transparency</h4>
              <p>We believe trust is earned through honesty. From pricing to certification, we maintain complete transparency in every transaction.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h4>Customer-First Approach</h4>
              <p>We offer personalized guidance, helping customers choose jewellery that suits their occasion, budget, and long-term value.</p>
            </div>
          </div>
        </div>

        {/* Journey Section */}
        <div className="history-section">
          <h3>Our Journey</h3>
          <div className="timeline">
            {[
              { year: '2002', title: 'Foundation', desc: 'Established as Manoj Abhushan Bhandar, a family-run jewellery store serving local communities in Rajasthan.' },
              { year: '2005', title: 'Growing Trust', desc: 'Became a well-known and trusted name in the regional jewellery market through consistent quality and ethical practices.' },
              { year: '2015', title: 'Modern Craftsmanship', desc: 'Adopted modern tools and design techniques while preserving traditional Rajasthani craftsmanship.' },
              { year: '2025', title: 'Digital Transformation', desc: 'Launched MAB Jewels as a digital-first jewellery platform, bringing trusted jewellery buying experiences online for customers across Rajasthan and India.' }
            ].map((item, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-year">{item.year}</div>
                <div className="timeline-content">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Leadership Team */}
        <div className="team-section">
          <h3>Our Leadership Team</h3>
          <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto 40px', color: '#555', lineHeight: '1.6' }}>
            MAB Jewels is jointly owned and operated by Jayprakash Soni and Manoj Soni, who have together led the business for decades, combining traditional craftsmanship with modern business practices. Today, Hemant Soni supports operational and quality management, ensuring the brand continues to uphold its legacy while adapting to modern standards.
          </p>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h4>Jayprakash Soni</h4>
              <p className="member-role">Founder & Co-Owner | Master Jeweller</p>
              <p className="member-description">With over 30 years of hands-on experience, he laid the foundation of trust and craftsmanship that defines MAB Jewels today.</p>
            </div>
            <div className="team-member">
              <div className="member-avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h4>Manoj Soni</h4>
              <p className="member-role">Co-Owner | Design Director</p>
              <p className="member-description">Leads creative design and innovation, blending traditional motifs with contemporary jewellery aesthetics.</p>
            </div>
            <div className="team-member">
              <div className="member-avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h4>Hemant Soni</h4>
              <p className="member-role">Quality & Compliance Manager</p>
              <p className="member-description">Oversees purity verification, BIS hallmark compliance, and quality control across all jewellery collections.</p>
            </div>
          </div>
        </div>

        {/* Certifications & Compliance - Updated */}
        <div className="certifications-section">
          <h3>Certifications & Compliance</h3>
          <div className="certifications-grid">
            <div className="certification-card">
              <div className="cert-icon">✓</div>
              <h4>BIS Hallmark Certified</h4>
              <p>Gold Jewellery</p>
            </div>
            <div className="certification-card">
              <div className="cert-icon">✓</div>
              <h4>GST Registered</h4>
              <p>Fully compliant business</p>
            </div>
            <div className="certification-card">
              <div className="cert-icon">✓</div>
              <h4>Quality Standards</h4>
              <p>Adherence to national trade standards</p>
            </div>
          </div>
          <p style={{ textAlign: 'center', marginTop: '20px', color: '#666' }}>Every purchase at MAB Jewels is backed by authentic certification and regulatory compliance.</p>
        </div>

        {/* Why Trust & Presence */}
        <div className="values-section">
          <h3>Why Customers Trust MAB Jewels</h3>
          <ul style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'left', listStyle: 'none', padding: 0 }}>
            {['Legacy jewellery business rooted in Rajasthan', 'BIS hallmarked and certified jewellery', 'Transparent pricing aligned with live gold rates', 'Trusted name associated with Manoj Abhushan Bhandar', 'Serving customers across Rajasthan with integrity'].map(item => (
              <li key={item} style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center' }}>
                <span style={{ color: 'green', marginRight: '10px' }}>✔</span> {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Explore More Links */}
        <div style={{ textAlign: 'center', margin: '60px 0 40px' }}>
          <h4 style={{ marginBottom: '20px', color: '#d4af37' }}>Explore More</h4>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <Link to="/jewellery" className="btn-secondary">View Gold Jewellery Collection</Link>
            <Link to="/gold-rate-rajasthan" className="btn-secondary">Today's Gold Rate in Rajasthan</Link>
            <Link to="/wedding-jewellery-rajasthan" className="btn-secondary">Wedding Jewellery in Rajasthan</Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AboutUsPage;
